import { render, staticRenderFns } from "./EstadoRetencionCombobox.vue?vue&type=template&id=949d62ec&scoped=true"
import script from "./EstadoRetencionCombobox.vue?vue&type=script&lang=js"
export * from "./EstadoRetencionCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949d62ec",
  null
  
)

export default component.exports